<template>
  <div class="dw-ctable">
    <div class="dw-ctable__head">
      <span>Target</span>
      <span>Frequency</span>
      <span>Next run</span>
      <span class="dw-ctable__when">When</span>
    </div>
    <div class="dw-ctable__body">
      <div v-for="row in rows" :key="row.id" class="dw-ctable__row">
        <span class="dw-ctable__name" :title="row.name">{{ row.name }}</span>
        <span class="dw-ctable__freq">{{ row.frequency }}</span>
        <span class="dw-ctable__at">{{ absolute(row.nextRun) }}</span>
        <span class="dw-ctable__when" :class="{ 'dw-ctable__when--due': row.overdue }">
          {{ row.overdue ? 'Due' : relative(row.nextRun) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CrawlScheduleList',
    props: {
      // [{ id, name, frequency, nextRun: moment, overdue? }]
      rows: { type: Array, default: () => [] }
    },
    methods: {
      relative(nextRun) {
        return nextRun ? nextRun.fromNow() : '—';
      },
      absolute(nextRun) {
        return nextRun ? nextRun.format('D MMM, HH:mm') : '—';
      }
    }
  };
</script>
